import { useState, useEffect } from "react";
import { type Subject } from "@core/grades/types";

interface UseActiveSubjectProps {
  subjects: Subject[];
}

export function useActiveSubject({ subjects }: UseActiveSubjectProps) {
  const [activeSubject, setActiveSubject] = useState<Subject | null>(null);

  useEffect(() => {
    if (subjects?.length > 0 && !activeSubject) {
      setActiveSubject(subjects[0]);
    }
  }, [subjects, activeSubject]);

  const handleSubjectChange = (subject: Subject) => {
    setActiveSubject(subject);
  };

  return {
    activeSubject,
    handleSubjectChange,
  };
}
